module.exports = __webpack_public_path__ + "static/img/ST-KILDA.d56e0e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ST-KILDA.svg
// module id = Eu2Y
// module chunks = 0